var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating4GrayOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0771 1.2063H1.07715V61.2063H61.0771V1.2063Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1606 34.688C46.1606 36.3454 45.8291 38.0029 45.3319 39.4946C43.3429 45.4615 37.7076 49.7709 31.0778 49.7709C24.4479 49.7709 18.8126 45.4615 16.8236 39.4946C16.3264 38.0029 15.9949 36.3454 15.9949 34.688H46.1606Z",
    fill: "#797979",
    stroke: "#797979",
    strokeWidth: 5.6693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3043 21.9247C22.6843 21.9247 24.6137 19.9953 24.6137 17.6153C24.6137 15.2353 22.6843 13.3059 20.3043 13.3059C17.9243 13.3059 15.9949 15.2353 15.9949 17.6153C15.9949 19.9953 17.9243 21.9247 20.3043 21.9247Z",
    fill: "#797979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8507 21.9247C44.2307 21.9247 46.16 19.9953 46.16 17.6153C46.16 15.2353 44.2307 13.3059 41.8507 13.3059C39.4707 13.3059 37.5413 15.2353 37.5413 17.6153C37.5413 19.9953 39.4707 21.9247 41.8507 21.9247Z",
    fill: "#797979"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating4GrayOutlined);
export default __webpack_public_path__ + "static/media/rating4-gray-outlined.87e0e45bfa665e2abc858eae7d24c691.svg";
export { ForwardRef as ReactComponent };